class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('change', this.onVariantChange.bind(this));
    this.variantClicked = false; // ✅ nuova variabile per distinguere caricamento da click
  }

  onVariantChange(event) {
    const formData = new FormData(this.form);
    const variantId = formData.get('id');
    const variant = this.getVariantData().find(v => v.id == variantId);

    if (variant) {
      this.currentVariant = variant;
      this.updateURL();
      this.updatePrice();
      this.updateMedia();
    }
  }

  updateMedia() {
    // ✅ Modificato: mostra solo al click manuale, non al load iniziale
    if (this.currentVariant && this.currentVariant.featured_media && this.variantClicked) {
      this.setActiveMedia(this.currentVariant.featured_media.id);
    }
  }

  updateURL() {
    if (this.currentVariant) {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updatePrice() {
    if (this.currentVariant) {
      const price = this.querySelector('.price');
      if (price) price.textContent = this.currentVariant.price;
    }
  }

  getVariantData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }

  setActiveMedia(mediaId) {
    const gallery = document.querySelector(`#MediaGallery-${this.dataset.section}`);
    if (!gallery) return;

    const media = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (media) {
      gallery.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
      media.classList.add('is-active');
    }
  }
}

customElements.define('product-form', ProductForm);
